<div class="navigation-container">
  <app-primary-nav></app-primary-nav>
  <app-secondary-nav></app-secondary-nav>
</div>
